import Image from "next/image";
import { IJustIn, Iposts } from '../../interfaces'
import { CountryCode, ModuleType } from '../../lib/constants'
import { Lead } from '../shared/lead/Lead'
import { NavLink } from '../ui'
import styles from './Trends.module.css'
import { cmsLoader } from "../../lib/helpers/imageLoader";
import { pushRoute } from "@/lib/helpers/common";
type props = {
    countryCode: CountryCode;
    JustinData: IJustIn[]
}


export function Justin({ JustinData, countryCode }: props) {    
    const siteURL = process.env.SITE_URL + "/" + countryCode;
    return (
        <section className={`section ${styles.justInSectionmain} bgGray`}>
            <div className="container">
                <h2 className={`font26 text222 mb12  ${styles.mresponce}`}>What’s the Buzz?</h2>
                <p className={`font16 text666 mb46 ${styles.mrespopara}`}>Tap into the latest interior design trends to reinvent your home.</p>
                <div className={styles.justInmainBox}>
                        <div className={styles.justInroomsBoxleft}>
                {JustinData.map((posts: Iposts ,index:number) =>
                                <div key={index} className={styles.jusInroomTiles}>
                                    <figure className="mb12" onClick={()=>pushRoute(`${siteURL}/trends/${posts.post_slug}`)}>
                                         <Image
                                            className="img-responsive"
                                            src={posts.post_relative}
                                            loader={cmsLoader}
                                            width={338}
                                            height={127}
                                            alt={posts.post_title}/>
                                    </figure>
                                    <NavLink href={`${siteURL}/trends/category/room/${posts.sub_cat_slug}`} className="link font10" >{posts.sub_cat_name}</NavLink>
                                    <NavLink href={`${siteURL}/trends/${posts.post_slug}`}> <p className="font16 text222 lineHeight20  lineClamp">{posts.post_title}</p></NavLink>
                                    </div>)}
                                </div>
                    <div className={styles.justInfillright}>
                        <div className={`formBox bgWhite ${styles.rightFilluser}`}>
                            <Lead ModuleType={ModuleType.INTERIOR} Title="Home Decor Services Made Simpler" ButtonText="Book Free Consultation" />

                        </div>

                    </div>
                </div>

            </div>
        </section >
    );
}